<template>
    <div>
        <div class="drawingScreenshotPopupContainer">
            <CustomDxPopup :ref="drawingScreenshotPopupRefName"
                     :drag-enabled="false"
                     :show-title="true"
                     title="Képernyőkép szerkesztése"
                     :onShowing="onDrawingScreenshotPopupShowing"
                     container="#app">

                <div class="tool dx-icon-undo" @click="onUndoClicked()"></div>
                <div class="tool dx-icon-redo" @click="onRedoClicked()"></div>
                <Editor :canvasWidth="editorCanvasWidth" :canvasHeight="editorCanvasHeight" ref="editor" editorId="ScreenshotEditorCanvas1" />

                <DxPopupToolbarItem :options="drawingPopupCloseButtonOptions"
                                    toolbar="bottom"
                                    location="after"
                                    widget="dxButton" />
            </CustomDxPopup>
        </div>
    </div>
</template>

<script>
    // HTML Canvas photo
    import * as htmlToImage from 'html-to-image';
    import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
    import DxPopup, {
        DxToolbarItem as DxPopupToolbarItem
    } from "devextreme-vue/popup";
    import DxButton from 'devextreme-vue/button';
    import Editor from 'vue-image-markup';
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import DxDropDownButton, { DxDropDownOptions, DxPosition } from 'devextreme-vue/drop-down-button';
    import CustomDxPopup from "./CustomDxPopup";

    export default {
        name: "ScreenshotMaker",
        components: {
            DxPopup,
            DxPopupToolbarItem,
            Editor,
            DxScrollView,
            CustomDxPopup
        },
        props: ["username", "user-roles"],
        data() {
            return {
                latestScreenshotDataUrl: '',
                latestScreenshotDateTime: null,
                drawingScreenshotPopupRefName: 'drawingScreenshot',
                editorCanvasWidth: 100,
                editorCanvasHeight: 100,
                drawingPopupCloseButtonOptions: {
                    text: "Bezárás",
                    onClick: () => {
                        this.drawingPopup.hide();
                        window.taskPrintScreen = this.$refs.editor.saveImage();
                        this.showTaskPopup();
                    }
                },
                drawingScreenshotPopupAttributes: {
                    class: 'drawingScreenshotPopup'
                },
                diagnosticsData: {}
            }
        },
        mounted() {
            this.$root.$on('make_screenshot', (nodeId, callbackFunction) => {
                this.makeScreenshot(nodeId, callbackFunction);
            });
            this.$root.$on('get_latest_screenshot', (callbackFunction) => {
                this.getLatestScreenshot(callbackFunction);
            });
            this.$root.$on('get_diagnostics_data', (callbackFunction) => {
                var jsonData = this._data;
                callbackFunction(this.$options._componentTag, JSON.stringify(jsonData));
            });
            this.diagnosticsData = {};
            this.$root.$emit('get_diagnostics_data', this.onDiagnosticsDataArrived);
        },
        methods: {
            onDiagnosticsDataArrived(index, jsonObj) {
                this.diagnosticsData[index] = jsonObj;
            },
            onDrawingScreenshotPopupShowing(e) {
                var content = e.component.content();
                if (!content.classList.contains("drawingScreenshotPopupContent")) {
                    content.classList.add("drawingScreenshotPopupContent");
                }
            },
            setEditorModeAndOptions() {
                let customizeFreeDrawing = { stroke: 'red', strokeWidth: "3" };
                this.$refs.editor.set('freeDrawing', customizeFreeDrawing);
            },
            onUndoClicked() {
                this.$refs.editor.undo();
                this.setEditorModeAndOptions();
            },
            onRedoClicked() {
                this.$refs.editor.redo();
                this.setEditorModeAndOptions();
            },
            getLatestScreenshot(callbackFunction) {
                callbackFunction(this.latestScreenshotDataUrl, this.latestScreenshotDateTime, this.diagnosticsData);
            },
            makeScreenshot(nodeId, callbackFunction) {
                var node = document.getElementById(nodeId);
                var thisVue = this;
                htmlToImage.toPng(node)
                    .then(function (dataUrl) {
                        thisVue.latestScreenshotDataUrl = dataUrl;
                        var thisMoment = new Date();
                        thisVue.latestScreenshotDateTime = thisMoment.toISOString();
                        thisVue.$root.$emit('screenshot_is_complete', nodeId);
                        callbackFunction(dataUrl);
                    })
                    .catch(function (error) {
                        callbackFunction(error);
                    });
            }
        }
    };
</script>

<style scoped lang="scss">
    .nav > li > a {
        text-decoration: none;
    }
    .nav > li > a > .img-circle {
        width: 100%;
        max-width: 20px;
        height: auto;
        border-radius: 50%;
        border: 0;
        position: relative;
        bottom: 1px;
        vertical-align:middle
    }
    .nav > li > a > span {
        margin-left: 5px;
        line-height: 24px;
        font-size: 14px;
    }
    ::v-deep .localDropdown {
        .dx-button-content {
            line-height: 21px;
            padding: 12px 18px 7px;
        }
        .dx-button-text {
            color: #ffffff;
        }
        .dx-button-mode-outlined {
            border: 0;
        }
        .dx-icon {
            vertical-align: bottom;
            height: 20px !important;
            width: 28px;
            margin-right: 0 !important;
        }
        .dx-icon.dx-icon-right{
            width: 0;
        }
        .dx-overlay-content {
            left: 10px;
        }
        .dx-button-text {
            display: none;
        }
    }
    ul.navbar-nav li {
        padding-left: 31px !important;
        line-height: 40px;
    }
    .bug-report a {
        color: #fff;
    }
    .bug-report-chooser {
        position: absolute;
        left: -120px;
        top: 40px;
        background-color: #012A4A;
        color: #fff;
    }
    ul.bug-report-chooser {
        list-style: none;
        padding: 0px;
    }
    .bug-report-chooser li {
        padding: 0px 20px;
        list-style: none;
        white-space: nowrap;
    }
    .notificationCount {
        position: relative;
        top: -2px;
        background-color: #ff0000;
        color: #fff;
        font-size: 11px;
        font-weight: bold;
        line-height: 22px;
        padding: 0px 0px;
        -webkit-border-radius: 22px;
        -moz-border-radius: 22px;
        border-radius: 22px;
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
    }
</style>
<style>
    .dx-scrollable.dx-scrollview.dx-widget .dx-scrollable-wrapper {
        border: none;
    }
    .dx-list-item-icon {
        vertical-align: bottom;
        height: 13px !important;
    }
    .dx-popup-content {
        text-align: left !important;
    }
</style>
